module.exports = __webpack_public_path__ + "static/media/Douche.8df8205c.mp3";